import React from "react";
import { ArrowUp } from "lucide-react";

const MetricTile = ({
  icon,
  value,
  label,
  color,
  trend,
  trendValue,
  customColors = {},
}) => {
  const tileColor = color || customColors.active || "#3b82f6";
  const trendUpColor = customColors.success || "#10b981";
  const trendDownColor = customColors.warning || "#f59e0b";

  return (
    <div
      className="dashboard-metric-tile"
      style={{ "--stats-accent": tileColor }}
    >
      <div className="stats-card__accent" aria-hidden="true" />
      <div
        className="dashboard-metric-tile__icon"
        style={{ backgroundColor: `${tileColor}1A`, color: tileColor }}
      >
        {icon}
      </div>
      <div className="dashboard-metric-tile__content">
        <div
          className="dashboard-metric-tile__label"
          style={{ color: customColors.textSecondary || "#64748b" }}
        >
          {label}
        </div>
      </div>
      <div className="dashboard-metric-tile__value-wrap">
        <div
          className="dashboard-metric-tile__value"
          style={{ color: customColors.textPrimary || "#1e293b" }}
        >
          {value || "—"}
        </div>
        {trend && trendValue && (
          <div className="dashboard-metric-tile__trend">
            <ArrowUp
              size={13}
              style={{ color: trend === "up" ? trendUpColor : trendDownColor }}
            />
            <span
              className="text-xs font-bold"
              style={{ color: trend === "up" ? trendUpColor : trendDownColor }}
            >
              {trendValue}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default MetricTile;
